/**
 * Included into the footer of pages.
 */

import * as variables from './variables';

import * as jQuery from 'jquery';

import './lib/AnimationEasing';

import "./lib/AnalyticsSetup";

import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.addStyleClasses(document.documentElement);

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);

import { MainMenu, CollapseExpandChildrenListener } from './component/MainMenu';
new MainMenu({
	menu: '#menu',
	menuTriggers: '.menuTrigger--open, .menuTrigger--close, .pageOverlay',
	nodeTrigger: '.nav--primary.mobile > .node--hasChild > a',
	styleClass: {
		menuOpen: 'hasMenuOpen',
		nodeOpen: 'isOpen',
	},
	listeners: [
		new CollapseExpandChildrenListener(400, 'easeOutExpo')
	]
});



//===================================================================
// Carousel Masthead
//===================================================================
// import entryVideo from './component/entryVideo';
// entryVideo('.featureCarousel__videoWrap');

import featureCarousel from './component/FeatureCarousel/FeatureCarousel';
const entryCarouselEl = document.querySelector('.featureCarousel') as HTMLElement;
if (entryCarouselEl) {
	const entryCarousel = new featureCarousel({
		analyticsCategory: 'Feature Carousel',
		carouselClass: 'featureCarousel',
		carouselEl: entryCarouselEl,
		duration: 6000, /* NOTE: if updating this value, update animation duration in CSS */
		doIndicatorClick: true,
	});
}
//===================================================================


//===================================================================
// Video - Lightbox
//===================================================================
import VideoLightbox from './component/VideoLightbox';
VideoLightbox();
//===================================================================


//===================================================================
// Warranty Form Lightbox
//===================================================================
import WarrantyFormLightbox from './component/WarrantyFormLightbox';
WarrantyFormLightbox();
//===================================================================


//===================================================================
// To fix scrollbar widths issue on Full Width blocks.
//===================================================================
import './lib/SetScrollBarWidthProperty';
//===================================================================


//===================================================================
// History Timeline - Pagination Functionality
//===================================================================
// import './lib/History-Timeline';
// import './component/HistoryTimeline';
//===================================================================


//===================================================================
// Literature Display Style
//===================================================================
// Keep as HTMLCollections
const literaturePQL = document.getElementsByClassName('plauditQueryLoop--literature');
const literatureTabs = document.getElementsByClassName('layoutType__trigger');
const literatureMain = document.getElementsByClassName('plauditQueryLoop__main');

if (literaturePQL.length > 0) {
	// Check localStorage on mount
	let activeTab = localStorage.getItem('activeLiteratureTab');
	let activeStyle = localStorage.getItem('activeLiteratureStyle');

	if (activeTab) {
		setActiveTab(activeTab);
	} else {
		// Set defaults
		activeTab = 'list';
		setActiveTab('list');
	}

	if (activeStyle) {
		setActiveStyle(activeStyle);
	} else {
		activeStyle = 'layoutType--list';
		setActiveStyle('layoutType--list');
	}

	// Set active tab
	function setActiveTab(tab:any) {
		// Remove active class
		Array.from(literatureTabs).forEach(t => {
			t.classList.remove('active');
		});

		// Add active class
		const activeTab = literatureTabs[tab];
		activeTab.classList.add('active');

		// Store in localStorage
		localStorage.setItem('activeLiteratureTab', tab);
	}

	// Set active style
	function setActiveStyle(style:any) {
		Array.from(literatureMain).forEach(main => {
			main.classList.remove('layoutType--list');
			main.classList.remove('layoutType--grid');
			main.classList.add(style);
		});
		localStorage.setItem('activeLiteratureStyle', style);
	}

	// Tab click handler
	Array.from(literatureTabs).forEach(tab => {
		tab.addEventListener('click', () => {
			const clickedId = tab.id;

			if (clickedId === 'list') {
				setActiveStyle('layoutType--list');
				setActiveTab('list');
			} else if (clickedId === 'grid') {
				setActiveStyle('layoutType--grid');
				setActiveTab('grid');
			}
		});
	});
}

import "./component/warranty-form-conditional-logic";

//===================================================================



// ---------------------------------------------------------------------------------------------- //
// Animations
//
// SEE EXAMPLE BELOW:
//
// import InViewObserver from './lib/InViewObserver';
// InViewObserver.createInstance([
// 	{
// 		observeSelector: '.pageContent > .wp-block-group, .callToAction, .pageFooter__content',
// 		minimum: 20,
// 		minimumUnit: "px"
// 	},
// 	{
// 		observeSelector: '.decorativeShape__canvas, .pageFooter__donutCanvas',
// 		minimum: 20,
// 		minimumUnit: "px"
// 	}
// ]);
// ---------------------------------------------------------------------------------------------- //



//=========================================================================
// Checks if Redirect Variable exists, if so, play the video in a lightbox
//=========================================================================

//=========================================================================
